import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { ScissorsIcon as Scissors, ArrowRightIcon as ArrowRight } from "@phosphor-icons/react";

/**
 * Shown to members who picked the Service Pro persona but never
 * submitted a provider application — they're invisible to clients (and
 * to admin approvals) until they do.
 */
export const ProviderApplicationNudge = ({ persona }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (persona !== "service_provider") return;
    api.get("/providers/mine", { silent: true })
      .then((r) => {
        const row = r.data;
        setShow(!row || row.provider === null || (!row.id && !row.business_name));
      })
      .catch(() => setShow(false));
  }, [persona]);

  if (!show) return null;
  return (
    <div className="mb-6 rounded-xl border-2 border-gold/60 bg-[#FBF7EC] p-5 flex items-start gap-4" data-testid="provider-application-nudge">
      <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-gold-gradient shrink-0">
        <Scissors size={18} weight="duotone" className="text-ink" />
      </span>
      <div className="flex-1 min-w-0">
        <p className="font-bold text-ink text-[15px]">Finish your free pro listing — you're almost there</p>
        <p className="text-[13px] text-[#3F3F3F] mt-1 leading-relaxed">
          You signed up as a service pro, but clients can't find or book you until your profile is
          submitted. It takes about 15 minutes: services, prices, photos, and payouts — then you're
          in the Find-a-Pro directory. No monthly fee, ever.
        </p>
        <Link
          to="/provider/me"
          className="mt-3 inline-flex items-center gap-1.5 bg-ink hover:bg-crimson text-white rounded-full px-5 py-2.5 text-[13px] font-semibold transition-colors"
          data-testid="provider-nudge-cta"
        >
          Finish my listing <ArrowRight size={14} weight="bold" />
        </Link>
      </div>
    </div>
  );
};

export default ProviderApplicationNudge;
